<div class="tv-round-input-extensible-persistent-label-no-border" [ngClass]="widthClass">
  <span class="tv-round-input-persistent-label">{{ selectedSellerPlaceholder }}</span>
  <mat-form-field>
    <input
      (keyup)="searchCommercial($event)"
      [formControl]="searchFormControl"
      [matAutocomplete]="autoSeller"
      matInput
    >
    <mat-autocomplete
      autoActiveFirstOption
      class="tv-custom-always-visible-scroll-bar tv-rounded-autocomplete-panel"
      #autoSeller="matAutocomplete"
      [displayWith]="displaySeller"
      (optionSelected)="selectSeller($event.option.value)">
      <mat-option
        *ngFor="let seller of sellerFiltered"
        class="tv-ns-select-option"
        [value]="seller">
        {{ getSellerValue(seller) }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
